/*
 * Wishlist de Ice Baby
 * ---------------------------------------------------------------------------
 * Guarda los productos marcados con el corazon en el navegador del visitante y
 * los lista en la pagina /pages/wishlist.
 *
 * NOTA DE IMPLEMENTACION: snippets/product-card.liquid trae su propio script en
 * linea que hacia lo mismo pero sin pagina. En vez de reescribir esa plantilla,
 * layout/theme.liquid marca window.__ibWishlistBound = true en el <head>, antes
 * de que el body se analice, con lo que aquel script se desactiva solo y este
 * toma el control. Si algun dia se reescribe la tarjeta, se puede borrar tanto
 * el script en linea como esa marca.
 *
 * OJO: sections/header.liquid tiene un TERCER script con la misma guarda, el que
 * pintaba el punto contador del corazon del header. Tambien queda apagado, asi
 * que ese punto lo pintamos nosotros en updateCounters().
 *
 * Formato guardado: [{ id: "7412345", handle: "cadena-rope-2mm" }, ...]
 * Las entradas viejas eran strings sueltos con el id. Se migran al vuelo y el
 * handle se rellena en cuanto el visitante vuelve a ver esa tarjeta.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ib-wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ----------------------------------------------------------- almacenamiento */

  function read() {
    var raw;
    try {
      raw = JSON.parse(localStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return [];
    }
    if (!Array.isArray(raw)) return [];
    return raw
      .map(function (entry) {
        if (typeof entry === 'string') return { id: entry, handle: null };
        if (entry && typeof entry.id === 'string') return { id: entry.id, handle: entry.handle || null };
        return null;
      })
      .filter(Boolean);
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* Modo privado o almacenamiento lleno: el corazon sigue funcionando en la
         sesion actual, simplemente no se recuerda. No rompemos la pagina. */
    }
    updateCounters(items.length);
  }

  function indexOfId(items, id) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return -1;
  }

  /* -------------------------------------------------------- corazon en tarjeta */

  function handleForButton(btn) {
    var card = btn.closest('product-card');
    return (card && card.getAttribute('handle')) || null;
  }

  function syncButton(btn) {
    var id = btn.getAttribute('data-wishlist-toggle');
    var items = read();
    var i = indexOfId(items, id);
    btn.setAttribute('aria-pressed', i === -1 ? 'false' : 'true');

    if (i !== -1 && !items[i].handle) {
      var handle = handleForButton(btn);
      if (handle) {
        items[i].handle = handle;
        write(items);
      }
    }
  }

  function syncAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
    updateCounters();
  }

  function updateCounters(count) {
    if (typeof count !== 'number') count = read().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });

    /* El corazon del header trae su propio punto contador, definido en
       sections/header.liquid. Lo pintaba un tercer script en linea que tambien se
       apaga con __ibWishlistBound, asi que el punto es responsabilidad nuestra. */
    document.querySelectorAll('[data-wishlist-count-dot]').forEach(function (dot) {
      dot.textContent = count > 9 ? '9+' : String(count);
      dot.classList.toggle('is-visible', count > 0);
    });
  }

  /* ------------------------------------------------------------------ eventos */

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      var id = toggle.getAttribute('data-wishlist-toggle');
      var items = read();
      var i = indexOfId(items, id);

      if (i === -1) {
        items.push({ id: id, handle: handleForButton(toggle) });
      } else {
        items.splice(i, 1);
      }

      write(items);
      document.querySelectorAll('[data-wishlist-toggle="' + id + '"]').forEach(syncButton);
      return;
    }

    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      var removeId = remove.getAttribute('data-wishlist-remove');
      var list = read();
      var j = indexOfId(list, removeId);
      if (j !== -1) {
        list.splice(j, 1);
        write(list);
      }
      renderPage();
      return;
    }

    var add = event.target.closest('[data-wishlist-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
    }
  });

  /* -------------------------------------------------------- pagina de wishlist */

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-wishlist-add');
    var fallback = button.getAttribute('data-product-url');
    button.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        /* Si el carrito rechaza el alta (stock, opciones obligatorias de una app
           de personalizacion...) mandamos a la ficha, que sabe pedir lo que falte. */
        window.location.href = fallback || root;
      });
  }

  function fetchProduct(handle) {
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).catch(function () {
      return null;
    });
  }

  function itemMarkup(product, savedId) {
    var image = product.featured_image
      ? product.featured_image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_500x$1$2')
      : null;
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }
    var singleVariant = product.variants.length === 1 && variant;
    var url = root.replace(/\/$/, '') + product.url;

    var action = singleVariant
      ? '<button type="button" class="wishlist-card__button" data-wishlist-add="' + variant.id + '" data-product-url="' + url + '">Añadir al carrito</button>'
      : '<a class="wishlist-card__button" href="' + url + '">' + (variant ? 'Ver opciones' : 'Ver producto') + '</a>';

    return (
      '<li class="wishlist-card">' +
      '<a class="wishlist-card__media" href="' + url + '">' +
      (image
        ? '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="500" height="500">'
        : '<span class="wishlist-card__placeholder"></span>') +
      '</a>' +
      '<div class="wishlist-card__body">' +
      '<a class="wishlist-card__title" href="' + url + '">' + product.title + '</a>' +
      '<p class="wishlist-card__price">' + money(product.price) +
      (product.compare_at_price && product.compare_at_price > product.price
        ? ' <s>' + money(product.compare_at_price) + '</s>'
        : '') +
      '</p>' +
      (variant ? '' : '<p class="wishlist-card__sold-out">Agotado</p>') +
      '<div class="wishlist-card__actions">' +
      action +
      '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + savedId + '">Quitar</button>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function renderPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (!container) return;

    var list = container.querySelector('[data-wishlist-list]');
    var empty = container.querySelector('[data-wishlist-empty]');
    var loading = container.querySelector('[data-wishlist-loading]');
    var items = read().filter(function (entry) { return entry.handle; });

    if (loading) loading.hidden = false;
    if (empty) empty.hidden = true;
    list.innerHTML = '';

    if (items.length === 0) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(items.map(function (entry) { return fetchProduct(entry.handle); })).then(function (products) {
      var html = '';
      var stillValid = read();
      var removed = false;

      products.forEach(function (product, index) {
        if (product) {
          html += itemMarkup(product, items[index].id);
        } else {
          /* El producto ya no existe: lo sacamos de la lista en vez de dejar un
             hueco que el visitante no puede quitar. */
          var k = indexOfId(stillValid, items[index].id);
          if (k !== -1) { stillValid.splice(k, 1); removed = true; }
        }
      });

      if (removed) write(stillValid);
      if (loading) loading.hidden = true;

      if (html === '') {
        if (empty) empty.hidden = false;
        return;
      }
      list.innerHTML = html;
    });
  }

  /* -------------------------------------------------------------------- arranque */

  function init() {
    syncAll();
    renderPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Las secciones que Prestige repinta (carruseles, filtros, quick buy) vuelven a
     inyectar tarjetas sin recargar la pagina: hay que volver a pintar corazones. */
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('ib:wishlist:sync', syncAll);
})();
